import React from 'react';
import PropTypes from 'prop-types';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './RecsFieldSetting.module.scss';

const PRIORITIES = [
  { value: 'NEGATIVE', labelKey: 'recommendations.fields.priority.negative' },
  { value: 'DECREASE', labelKey: 'recommendations.fields.priority.decrease' },
  { value: 'IGNORE', labelKey: 'recommendations.fields.priority.ignore' },
  { value: 'LOW', labelKey: 'recommendations.fields.priority.low' },
  { value: 'NORMAL', labelKey: 'recommendations.fields.priority.normal' },
  { value: 'BOOST', labelKey: 'recommendations.fields.priority.boost' },
];

const RecsFieldSetting = ({ value, title, description, onChange, id }) => {
  const localizeMessage = useLocalizedMessage();

  return (
    <div className={styles.row} data-testid="recommendation-field-setting">
      <div className={styles.identity}>
        <span className={styles.title}>{title}</span>
        {description && <span className={styles.description}>{description}</span>}
      </div>
      <div
        className={styles.priorityControl}
        role="radiogroup"
        aria-label={localizeMessage('recommendations.fields.priority.ariaLabel', { field: title })}
      >
        {PRIORITIES.map(priority => {
          const selected = priority.value === value;
          return (
            <button
              key={priority.value}
              type="button"
              role="radio"
              aria-checked={selected}
              data-priority-value={priority.value}
              className={`${styles.priorityOption} ${selected ? styles.priorityOptionActive : ''}`.trim()}
              onClick={() => onChange(id, priority.value)}
            >
              {localizeMessage(priority.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

RecsFieldSetting.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.oneOf(PRIORITIES.map(priority => priority.value)).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RecsFieldSetting.defaultProps = {
  description: null,
};

export default RecsFieldSetting;
